function canPaginate($scope, $location) {
    _.extend($scope,
        _.pick($location.search(), 'q', 's', 'p'), {

            query(q) {
                return $location.search('q', q);
            },

            sort(s) {
                return $location.search('s', ($scope.s !== s ? s : `-${s}`));
            },

            page(p) {
                return $location.search('p', p);
            }
        }
    );
}

export { canPaginate };


// WEBPACK FOOTER //
// ./mixins/can_paginate.js